/* tslint:disable */
/* eslint-disable */

/**
 * Trend gegenüber dem vorherigen Snapshot
 */
export enum WorkTicketTopIssueTrendEnum {
  New = 'new',
  Up = 'up',
  Down = 'down',
  Stable = 'stable'
}
